var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ElCheckbox } from "element-plus";
import { useBuiltComponent, useBuiltComponentVariable, } from "src/shared/store/component-built/composables";
import { computed, ref, toRef } from "vue";
import { useComponentStoreV2 } from "src/shared/store/component";
import notificationService from "../../ui/notification/notification-service";
import { getErrorMessage } from "src/shared/store/common/Exception";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateOrDeleteComponentVariableCheckbox',
    props: {
        componentId: {},
        variableName: {},
        variableDisplayName: {},
        type: {}
    },
    setup(__props) {
        const componentStore = useComponentStoreV2();
        const props = __props;
        const { builtComponentVariable } = useBuiltComponentVariable(toRef(props, "componentId"), toRef(props, "variableName"));
        const { builtComponent } = useBuiltComponent(toRef(props, "componentId"));
        const isLoading = ref(false);
        const isChecked = computed({
            get() {
                return !!builtComponentVariable.value;
            },
            set(value) {
                if (value) {
                    createVariable();
                }
                else {
                    destroyVariable();
                }
            },
        });
        const createVariable = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            isLoading.value = true;
            try {
                yield componentStore.createComponentVariableSimple(props.componentId, props.variableName, props.type);
                notificationService.success(`${props.variableDisplayName} has been added to ${(_a = builtComponent.value) === null || _a === void 0 ? void 0 : _a.getDisplayName()}`);
            }
            catch (e) {
                notificationService.error(getErrorMessage(e));
            }
            finally {
                isLoading.value = false;
            }
        });
        const destroyVariable = () => __awaiter(this, void 0, void 0, function* () {
            var _b;
            isLoading.value = true;
            try {
                yield componentStore.deleteComponentVariable(props.componentId, props.variableName);
                notificationService.success(`${props.variableDisplayName} has been removed from ${(_b = builtComponent.value) === null || _b === void 0 ? void 0 : _b.getDisplayName()}`);
            }
            catch (e) {
                notificationService.error(getErrorMessage(e));
            }
            finally {
                isLoading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElCheckbox), {
                modelValue: isChecked.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isChecked).value = $event)),
                disabled: isLoading.value
            }, null, 8 /* PROPS */, ["modelValue", "disabled"]));
        };
    }
});
